import { RudderAnalytics } from '@rudderstack/analytics-js'

const WRITE_KEY = import.meta.env.VITE_RUDDERSTACK_WRITE_KEY
const DATA_PLANE_URL = import.meta.env.VITE_RUDDERSTACK_DATA_PLANE

const rudderAnalytics = new RudderAnalytics()
rudderAnalytics.load(WRITE_KEY, DATA_PLANE_URL)

export { rudderAnalytics }
